import React,{useState, useEffect} from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import './RecipientInput.css'

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control form-control-lg"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function Input({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  vers = false,
  versData,
  ...props
}) {
  return (
    <>
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>
      )}
      <div className="col-lg-6 col-xl-6">
        <input
          type={type}
          className={getFieldCSSClasses(
            touched[field.name],
            errors[field.name]
          )}
          {...field}
          {...props}
        />
        {vers ? (
          <span className="form-text text-muted" style={{ display: "block" }}>
            Versi {versData}
          </span>
        ) : null}
        {withFeedbackLabel && (
          <FieldFeedbackLabel
            error={errors[field.name]}
            touched={touched[field.name]}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )}
      </div>
    </>
  );
}
export function InputBps({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  vers = false,
  versData,
  ...props
}) {
  return (
    <>
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>
      )}
      <div className="col-lg-9 col-xl-6">
        <input
          type={type}
          className={getFieldCSSClasses(
            touched[field.name],
            errors[field.name]
          )}
          {...field}
          {...props}
        />
      <span className="form-text text-muted" style={{ display: "block" }}>
            diisi dengan nomor BPS atas pendaftaran proyek dan kontraktor utama.
          </span>
        {/* {withFeedbackLabel && (
          <FieldFeedbackLabel
            error={errors[field.name]}
            touched={touched[field.name]}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )} */}
      </div>
    </>
  );
}

export function InputSplit({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  ...props
}) {
  return (
    <>
      {label && <label>{label}</label>}

      <input
        type={type}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}

export function InputTagging({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  vers = false,
  versData,
  ...props
}) {
  useEffect(()=> {
      // setRecipients( values[field.name] ? values[field.name].split(",").join(" ").split(" ") : [])
      // setRecipients(values[field.name].split(" "))
      setRecipients(values[field.name] ? values[field.name].includes(" ") ? values[field.name].split(" ") : values[field.name].split(",") : [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[values])
  const [recipients, setRecipients] = useState([]);
  // const [recipients, setRecipients] = useState(values[field.name].split(","));
  const [tag, setTag] = useState('')
  const handleInputKeyPress = (e) => {
    if (e.key === " " ||
    e.code === "Space" ||      
    e.keyCode === 32   ) {
      setRecipients([...recipients, "#" + e.target.value]);
      // setFieldValue(field.name, [...recipients, "#" + e.target.value])
      setFieldValue(field.name, [...recipients, "#" + e.target.value.replace(" ","")].toString())
      setTag('');
      // console.log(recipients.toString())
      // const newEmail = email.trim();
      // if (newEmail !== '' && validateEmail(newEmail)) {
      //   setRecipients([...recipients, newEmail]);
      //   setEmail('');
      // }
    }
  
  };
  const removeRecipient = (index) => {
    const updatedRecipients = recipients.filter((_, i) => i !== index);
    setRecipients(updatedRecipients);
    setFieldValue(field.name, updatedRecipients.toString());
  };
  const handleInputChange = (e) => {
    // setFieldValue(field.name, e.target.value);
    setTag(e.target.value)
  };
// console.log(recipients)
  // console.log(values[field.name])
  return (
    <>
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>
      )}
      <div className="col-lg-9 col-xl-6">
      <div className="recipient-container">
      {recipients.map((recipient, index) => (
        <span key={index} className="recipient" onClick={() => removeRecipient(index)}>
          {`${recipient} `}
          <span className="close-icon">X</span>
        </span>
      ))}
       
        </div>
        <input
          type={type}
          className={getFieldCSSClasses(
            touched[field.name],
            errors[field.name]
          )}
          value={tag}
          onChange={handleInputChange}
          onKeyUp={handleInputKeyPress}
          placeholder={field.name}
          disabled={props.disabled}
        />
        {/* <input
          type={type}
          // className="email-input"
          className={getFieldCSSClasses(
            touched[field.name],
            errors[field.name]
          )}
          // value={values[field.name]}
          onChange={handleInputChange}
          onKeyUp={handleInputKeyPress}
          placeholder="Add recipient"
          {...field}
          {...props}
        /> */}
      </div>
    </>
  );
}

export function InputForm({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  vers = false,
  versData,
  ...props
}) {
  return (
    <>
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>
      )}
      <div className="col-lg-9 col-xl-6">
        <input
          type={type}
          className={getFieldCSSClasses(
            touched[field.name],
            errors[field.name]
          )}
          {...field}
          {...props}
        />
        {vers ? (
          <span className="form-text text-muted" style={{ display: "block" }}>
            Versi {versData}
          </span>
        ) : null}
        {withFeedbackLabel && (
          <FieldFeedbackLabel
            error={errors[field.name]}
            touched={touched[field.name]}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )}
      </div>
    </>
  );
}


export function InputKeterangan({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  vers = false,
  versData,
  ...props
}) {
  return (
    <>
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>
      )}
      <div className="col-lg-6 col-xl-6">
        <input
          type={type}
          className={getFieldCSSClasses(
            touched[field.name],
            errors[field.name]
          )}
          {...field}
          {...props}
        />
          <div className="d-flex align-items-center">
                          <div className="mr-2 text-muted">
                            Keterangan dapat diisi referensi BKP/JKP.
                            <br/>
                            Contoh : Satuan BKP/JKP, dll.
                          </div>
                        </div>
        {vers ? (
          <span className="form-text text-muted" style={{ display: "block" }}>
            Versi {versData}
          </span>
        ) : null}
        {withFeedbackLabel && (
          <FieldFeedbackLabel
            error={errors[field.name]}
            touched={touched[field.name]}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )}
      </div>
    </>
  );
}

export function InputRequired({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  vers = false,
  versData,
  ...props
}) {
  return (
    <>
      {label && (
        <label className="col-xl-3 col-lg-3 col-form-label">{label}
        <span
        // style={{
        //   color: "red",
        //   fontSize: "20px",
        //   position: "absolute",
        // }}
        style={{
          color: "red",
          fontSize: "14px", // smaller font size for superscript
          verticalAlign: "super", // makes it superscript
          position: "static", // remove absolute to avoid layout issues
        }}
      >
        &nbsp;*
      </span></label>
      )}
      <div className="col-lg-6 col-xl-6">
        <input
          type={type}
          className={getFieldCSSClasses(
            touched[field.name],
            errors[field.name]
          )}
          {...field}
          {...props}
        />
        {vers ? (
          <span className="form-text text-muted" style={{ display: "block" }}>
            Versi {versData}
          </span>
        ) : null}
        {withFeedbackLabel && (
          <FieldFeedbackLabel
            error={errors[field.name]}
            touched={touched[field.name]}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )}
      </div>
    </>
  );
}